import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'notificationTypePipe'
})
export class NotificationTypePipe implements PipeTransform {

  transform(value: String, args?: any): String {
    let name;
    switch (value) {
      case 'START_LICENCE':
        name = 'Inicio de licencia'
        break;
      case 'END_SUBJECT_STAFF':
        name = 'Fin de cargo'
        break;
      case 'DOWN_USE':
        name = 'Baja de USE especial'
        break;
      case 'MINISTRY':
        name = 'Notificacion Ministerio'
        break;
      case 'SCHOOL':
        name = 'Notificacion Escuela'
        break;
    }
    return name;
  }

}



// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/pipes/notification-type.pipe.ts